import { AUTH_TOKEN } from 'app/constants';
import { HttpError, HttpErrorProps } from 'app/components/utils/http-error';

export interface PrioritiesRequest {
  EntityID: string;
  Value: number;
}

export const updateTaskPriority = async (
  appID: string,
  request: PrioritiesRequest[]
): Promise<void> => {
  const response = await fetch(
    `${process.env.REACT_APP_TRAFFIC_EXCHANGE_CONSOLE_API_URL}/apps/${appID}/tasks/priorities`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN) || ''}`
      },
      body: JSON.stringify(request)
    }
  );

  if (!response.ok) {
    if (response.body) {
      return response
        .clone()
        .json()
        .then((errorInfo: HttpErrorProps) => {
          return Promise.reject(
            new HttpError(
              `Failed to create task: ${response.statusText}`,
              response.status,
              errorInfo
            )
          );
        });
    } else {
      return Promise.reject(
        new HttpError(`Failed to create task: ${response.statusText}`, response.status)
      );
    }
  }
  return await response.json();
};
